export default __webpack_public_path__ + "static/media/img_company_header6.46fd8090.png";